"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const toolkit_1 = require("@reduxjs/toolkit");
const theme_1 = __importDefault(require("../../../styles/theme"));
const webViewer_1 = __importDefault(require("../../../components/webViewer/webViewer"));
const primaryButton_1 = __importDefault(require("../../../components/primaryButton/primaryButton"));
const surveySlice_1 = require("../surveySlice");
const store_1 = require("../../../store");
const homeSlice_1 = require("../../home/homeSlice");
const icon_1 = require("../../../components/icon/icon");
const styles_1 = __importDefault(require("../../../styles/styles"));
const colors_1 = __importDefault(require("../../../styles/colors"));
const text_1 = __importStar(require("../../../components/text/text"));
const utils_1 = require("../../../utils/utils");
const constants_1 = require("../../../constants/constants");
const analytics_1 = require("../../../utils/analytics/analytics");
const AcceptDecline = ({ documentUrl, documentType, loanApplicationId, errors, specialNavigation, }) => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const screenHeight = react_native_1.Dimensions.get('window').height;
    const setResponse = async (answer) => {
        const payload = {
            decision: answer,
            loan_application_id: loanApplicationId,
            document_type: documentType,
        };
        const result = await dispatch((0, surveySlice_1.answerDocument)(payload));
        logEventWithExtraProperties('api_call', {
            name: 'submit_document_by_type',
            status: 'submitted',
            location: 'screen_AcceptDecline',
            type: documentType,
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'submit_document_by_type',
                status: 'success',
                location: 'screen_AcceptDecline',
                type: documentType,
            });
            dispatch((0, homeSlice_1.addMessages)([
                {
                    title: 'Thank you.',
                    message: '',
                    iconType: icon_1.APPMESSAGE_CHECK_CIRCLE,
                    iconSize: 55,
                    buttonText: 'GO TO HOME',
                    actionButton: specialNavigation,
                },
            ]));
            dispatch((0, homeSlice_1.showMessage)());
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'submit_document_by_type',
                status: 'fail',
                location: 'screen_AcceptDecline',
                type: documentType,
            });
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_native_1.View, { style: { height: 0.85 * screenHeight } },
            !!errors && (react_1.default.createElement(react_native_1.View, { style: [
                    styles_1.default.mainContainerPadding,
                    styles_1.default.minimumMarginBetweenElementsVertically,
                    styles_1.default.flexDirectionColumn,
                    styles_1.default.centerChildHorizontalVertical,
                    { marginTop: 20 },
                ] },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: colors_1.default.COLOR_CRITICAL }, `${(0, utils_1.getError)('non_field_errors', errors)
                    ? (0, utils_1.getError)('non_field_errors', errors)
                    : constants_1.DEFAULT_ERROR_MESSAGE}`))),
            react_1.default.createElement(webViewer_1.default, { docSrc: documentUrl })),
        react_1.default.createElement(react_native_1.View, { style: [
                styles_1.default.flexOne,
                styles_1.default.flexDirectionRow,
                { padding: 2, height: 0.15 * screenHeight },
            ] },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
                react_1.default.createElement(primaryButton_1.default, { disabled: false, title: "Accept", textColor: colors_1.default.COLOR_WHITE, onPress: () => setResponse('approve'), eventName: "accept_button" })),
            react_1.default.createElement(react_native_1.View, { style: { paddingHorizontal: 5 } }),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
                react_1.default.createElement(primaryButton_1.default, { disabled: false, color: theme_1.default.colors.COLOR_CRITICAL, title: "Decline", textColor: colors_1.default.COLOR_WHITE, onPress: () => setResponse('reject'), eventName: "decline_button" })))));
};
exports.default = AcceptDecline;
